module.exports = __webpack_public_path__ + "static/media/bienban.9eab7761.png";